import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/marketing/Navbar";
import { useAuth } from "../context/AuthContext";

export default function SignUp() {
  const [form, setForm] = useState({ email: "", name: "", workspace: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const { signUp } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const auth = await signUp(form);
      // Platform staff (bench domain) skip pricing — they're not paying customers.
      const staff = ["readonly", "support", "admin"].includes(auth?.user?.platform_role);
      nav(staff ? "/staff" : "/pricing?welcome=1");
    } catch (ex) {
      const detail = ex?.response?.data?.detail;
      if (Array.isArray(detail)) {
        setErr(detail.map(e => e.msg).join(", "));
      } else if (typeof detail === "string") {
        setErr(detail);
      } else {
        setErr("Sign up failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-16">
        <h1 className="font-display text-4xl">Start tracking in 30 seconds.</h1>
        <p className="text-[#3f4a44] mt-2 text-sm">Free for 30 days. No credit card required.</p>
        <form onSubmit={submit} className="mt-8 space-y-4 bg-white p-6 rounded-xl border border-cream">
          <label className="block text-sm">
            <span className="font-medium">Work email</span>
            <input type="email" required value={form.email} onChange={set("email")}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40" />
          </label>
          <label className="block text-sm">
            <span className="font-medium">Your name</span>
            <input required value={form.name} onChange={set("name")}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40" />
          </label>
          <label className="block text-sm">
            <span className="font-medium">Company / workspace</span>
            <input required value={form.workspace} onChange={set("workspace")}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40" />
          </label>
          <label className="block text-sm">
            <span className="font-medium">Password</span>
            <input type="password" required minLength={6} value={form.password} onChange={set("password")}
              className="mt-1 w-full border border-cream rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-coral/40" />
          </label>
          {err && <div className="text-xs text-red-600">{err}</div>}
          <button type="submit" disabled={loading} className="btn-coral w-full py-2.5 rounded-md text-sm font-medium">
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>
        <p className="text-sm text-center mt-4 text-[#3f4a44]">
          Already have an account? <Link to="/signin" className="text-coral font-medium">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
